import request from "@/utils/Request";
import {CisEndpoints} from "@/services/cis/endpoints";

const getCountryList = async () => {
  return request.unauthorizedAxios().get(CisEndpoints.CIS_COUNTRY_GET_COUNTRY_LIST);
}

const getCountryState = async (code: string) => {
  return request.unauthorizedAxios().get(`${CisEndpoints.CIS_COUNTRY_GET_COUNTRY_STATE}?country=${code}`);
}


const CountryService = {
  getCountryList,
  getCountryState,
};
export default CountryService
